module.exports = __webpack_public_path__ + "images/scandinavian-2-3baa52260de344c27f00b76c7974ac71.jpg";